export const allowedVideoTypes = ['video/mp4', 'video/quicktime'];
export const landscapeVideoMinLength = 60;
